<template>
  <div class="highlight">
    <h1>{{statistic.label}}</h1>
    <div class="count"><span class="value">{{statistic.value}}<span v-if="statistic.unit" class="unit">{{statistic.unit}}</span></span></div>
  </div>
</template>
<style scoped>
.highlights {
  display: flex;
  color: #292c33;
  background-color: #e1e0e1;
  border-radius: 3px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  margin-top: 20px;
}

.highlights .highlight {
  width: 25%;
  padding: 20px;
  background: white;
  margin: 1px;
}

.highlight h1 {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 20px;
}
.highlight .value{
  white-space: nowrap;
}
.highlight .unit{
  margin-left:10px;
}
.highlight div.count {
  margin-top: 15px;
  font-size: 40px;
  font-weight: bold;
  line-height: 49px;
}

.graphs {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 10px;
}

.graph {
  width: calc(50% - 5px);
  margin-top: 20px;
  height: 400px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
}
</style>
<script>
export default {
    props :
    {
        statistic:{type:Object, required:true}
    }
};
</script>